import { getProducts } from '@Actions';
import { getUsers } from '@Actions/users';
import { RenderComponentOrLoading, StylovyzeForm } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import {
	useGetExternalUsersFromPaginated,
	useGetInternalUsersFromPaginated,
} from '@Utils/parseUsersUtil';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useNavigateTo from '../../hooks/useNavigateTo';
import ManageUsers from './ManageUsers';

export default function ManageUsersWithForm() {
	useNavigateTo();
	const dispatch = useDispatch();
	const { subscriptionId } = useParams<{ subscriptionId: string }>();
	const { initialized } = useSelector(getValue).users.paginatedUsers;

	const internalUsers = useGetInternalUsersFromPaginated();
	const externalUsers = useGetExternalUsersFromPaginated();

	const internalStringUsers = internalUsers
		.filter(el => el.entitlements.includes(subscriptionId))
		.map(el => el.id);
	const externalStringUsers = externalUsers
		.filter(el => el.entitlements.includes(subscriptionId))
		.map(el => el.id);

	useEffect(() => {
		dispatch(
			getUsers({
				pageSize: 1000,
				page: 1,
				blocked: false,
			}),
		);
		dispatch(getProducts());
	}, []);

	return (
		<RenderComponentOrLoading loading={!initialized}>
			<StylovyzeForm
				onSubmit={() => void 0}
				initialValues={{
					internalUsers: internalStringUsers,
					externalUsers: externalStringUsers,
				}}
				enableReinitialize
				mode="edit">
				{() => (
					<form>
						<ManageUsers />
					</form>
				)}
			</StylovyzeForm>
		</RenderComponentOrLoading>
	);
}
